import { TranslateService } from '@ngx-translate/core';

export const enum PatientCGStatus {
  REGISTERED = '0',
  CARE_GROUP_ASSIGNED = '1',
  INVITATION_SMS_SENT = '2',
  APP_INSTALLED = '3',
  VERFICATION_DECLINED = '4',
  VERIFICATION_ACCEPTED = '5',
  TERMS_CONDITIONS_DECLINED = '6',
  TERMS_CONDITIONS_ACCEPTED = '7',
  INVITE_CG_LATER = '8',
  CG_INVITED = '9',
  ACTIVE = '10',
}

export const enum Occurrence {
  NEW_INCIDENCE = 'New incidence',
  RELAPSE = 'Relapse',
  PREVALENT = 'Prevalent'
}

export const OccurrenceMap = {
  [Occurrence.NEW_INCIDENCE]: {
    label: 'New incidence',
  },
  [Occurrence.RELAPSE]: {
    label: 'Relapse',
  },
  [Occurrence.PREVALENT]: {
    label: 'Prevalent',
  },
};

export const enum TreatmentStageId {
  DIAGNOSED = 1,
  INDUCTION_THERAPY_TO_BE_STARTED,
  INDUCTION_THERAPY_IN_PROGRESS,
  MAINTENANCE_THERAPY_TO_BE_STARTED,
  MAINTENANCE_THERAPY_IN_PROGRESS,
}

export const treatmentStageIdMap = (translate: TranslateService) => {
  return {
    [TreatmentStageId.DIAGNOSED]: {
      label: translate.instant('diagnosedLbl'),
    },
    [TreatmentStageId.INDUCTION_THERAPY_TO_BE_STARTED]: {
      label: translate.instant('inductionTherapyStartLbl'),
    },
    [TreatmentStageId.INDUCTION_THERAPY_IN_PROGRESS]: {
      label: translate.instant('inductionTherapyProgressLbl'),
    },
    [TreatmentStageId.MAINTENANCE_THERAPY_TO_BE_STARTED]: {
      label: translate.instant('maintainanceTherapyStartLbl'),
    },
    [TreatmentStageId.MAINTENANCE_THERAPY_IN_PROGRESS]: {
      label: translate.instant('maintainanceTherapyProgressLbl'),
    },
  };
};

export const enum CancerStageType {
  NotSure,
  Stage1,
  Stage2,
  Stage3,
  Stage4,
  NotYetDefined,

}

export const cancerStageTypeMap = (translate: TranslateService) => {
  return {
    // [CancerStageType.NotSure]: {
    //   label: translate.instant('notSureLbl'),
    //   priority: 1,
    // },
    // [CancerStageType.NotYetDefined]: {
    //   label: translate.instant('notYetDefinedLbl'),
    //   priority: 2,
    // },
    [CancerStageType.Stage1]: {
      label: translate.instant('induction'),
      priority: 3,
    },
    [CancerStageType.Stage2]: {
      label: translate.instant('consolidation'),
      priority: 4,
    },
    [CancerStageType.Stage3]: {
      label: translate.instant('maintenance'),
      priority: 5,
    },
    // [CancerStageType.Stage4]: {
    //   label: '4',
    //   priority: 6,
    // },

  };
}

export const enum TreatmentJourney {
  JustDiagnosed = 1,
  TreatmentStarted
}

export const treatmentJourneyMap = (translate: TranslateService) => {
  return {
    [TreatmentJourney.JustDiagnosed]: {
      label: translate.instant('justDiagnosedLbl'),
    },
    [TreatmentJourney.TreatmentStarted]: {
      label: translate.instant('treatmentStartedLbl'),
    }
  };
};

export const enum TreatmentJourneyDetails {
  ChemotherapyPlanned = 1,
  RadiationPlanned,
  SurgeryPlanned,
  ChemotherapyOnGoing,
  RadiationOnGoing,
  SurgeryPlannedAndTreatmentStarted,
  SurgeryCompleted,
  ChemotherapyCompleted,
  RadiationCompleted
}

export const treatmentJourneyDetailsMap = (translate: TranslateService, journeyType: TreatmentJourney) => {
  if (journeyType === TreatmentJourney.JustDiagnosed) {
    return {
      [TreatmentJourneyDetails.ChemotherapyPlanned]: {
        label: translate.instant('chemoPlannedLbl'),
      },
      [TreatmentJourneyDetails.RadiationPlanned]: {
        label: translate.instant('radioPlannedLbl'),
      },
      [TreatmentJourneyDetails.SurgeryPlanned]: {
        label: translate.instant('surgeryPlannedLbl'),
      }
    };
  } else {
    return {
      [TreatmentJourneyDetails.ChemotherapyOnGoing]: {
        label: translate.instant('chemoOngoingLbl'),
      },
      [TreatmentJourneyDetails.RadiationOnGoing]: {
        label: translate.instant('radioOngoingLbl'),
      },
      [TreatmentJourneyDetails.SurgeryPlannedAndTreatmentStarted]: {
        label: translate.instant('surgeryPlannedAndTreatmentStartedLbl'),
      },
      [TreatmentJourneyDetails.SurgeryCompleted]: {
        label: translate.instant('surgeryCompletedLbl'),
      },
      [TreatmentJourneyDetails.ChemotherapyCompleted]: {
        label: translate.instant('chemoCompletedLbl'),
      },
      [TreatmentJourneyDetails.RadiationCompleted]: {
        label: translate.instant('radioCompletedLbl'),
      }
    };
  }
};



export const enum DocSpeciality {
  ONCOLOGIST = 'Oncologist',
  PSYCHOLOGIST = 'Psychologist',
  NUTRITIONIST = 'Nutritioninst',
  OTHERS = 'Others',
}

export const enum MedicineRoute {
  ORAL = 'Oral',
  IV = 'IV',
  SC = 'SC',
}

export const RouteMap = {
  [MedicineRoute.ORAL]: {
    label: 'Oral',
  },
  [MedicineRoute.IV]: {
    label: 'IV',
  },
  [MedicineRoute.SC]: {
    label: 'SC',
  },
};

export const enum PrescriptionType {
  NEW_PRESCRIPTION = 'New Prescription',
  ACTIVE_PRESCRIPTION = 'Active Prescription',
  OLD_PRESCRIPTION = 'Old Prescription',
}

export const prescriptionTypeMap = (translate: TranslateService) => {
  return {
    [PrescriptionType.NEW_PRESCRIPTION]: {
      label: translate.instant('newpresLbl'),
      name: PrescriptionType.NEW_PRESCRIPTION,
    },
    [PrescriptionType.ACTIVE_PRESCRIPTION]: {
      label: translate.instant('activePresLbl'),
      name: PrescriptionType.ACTIVE_PRESCRIPTION,
    },
    [PrescriptionType.OLD_PRESCRIPTION]: {
      label: translate.instant('oldPresLbl'),
      name: PrescriptionType.OLD_PRESCRIPTION,
    },
  };
};

export const translatedPresLabel = (
  translate: TranslateService,
  key: PrescriptionType,
) => {
  const translatedList = prescriptionTypeMap(translate);

  return translatedList[key].label;
};

export const enum PrescriptionTag {
  NEW = 'New',
  ACTIVE = 'Active',
  OLD = 'Old',
}

export const enum PrescriptionCardClass {
  NEW = 'new-pres',
  ACTIVE = 'active-pres',
  OLD = 'old-pres',
}

export const enum Administer {
  AT_HOME = 'AtHome',
  AT_HOSPITAL = 'AtHospital',
}

export const administerMap = (translate: TranslateService) => {
  return {
    [Administer.AT_HOME]: {
      label: translate.instant('atHomeLbl'),
      value: Administer.AT_HOME,
    },
    [Administer.AT_HOSPITAL]: {
      label: translate.instant('atHospitalLbl'),
      value: Administer.AT_HOSPITAL,
    },
  };
};

export const enum Reminder {
  ON = 'On',
  OFF = 'Off',
  NA = 'NA',
}

export const enum FoodRestriction {
  BeforeFood = 'BeforeFood',
  AfterFood = 'AfterFood',
  WithFood = 'WithFood',
  NoRestrictons = 'None',
}

export const restrictionMap = (translate: TranslateService) => {
  return {
    [FoodRestriction.BeforeFood]: {
      label: translate.instant('beforeFoodLbl'),
      img: './assets/before-food.png',
    },
    [FoodRestriction.AfterFood]: {
      label: translate.instant('afterFoodLbl'),
      img: './assets/after-food.png',
    },
    [FoodRestriction.WithFood]: {
      label: translate.instant('withFoodLbl'),
      img: './assets/with-food.png',
    },
    [FoodRestriction.NoRestrictons]: {
      label: translate.instant('noneLbl'),
      img: null,
    },
  };
};

export const enum PatientRiskCategory {
  Man = 1,
  ChildBearingPotential = 2,
  NoChildBearingPotential = 3
}

export const riskCategoryMap = (translate: TranslateService) => {
  return {
    [PatientRiskCategory.Man]: {
      label: translate.instant('manLbl'),
    },
    [PatientRiskCategory.ChildBearingPotential]: {
      label: translate.instant('childBearingPotentialLbl'),
    },
    [PatientRiskCategory.NoChildBearingPotential]: {
      label: translate.instant('noChildBearingPotentialLbl'),
    }
  };
};

export const enum PrescriptionDosage {
  ONCE_A_DAY = 'Once a day',
  TWICE_A_DAY = 'Twice a day',
  THRICE_A_DAY = 'Thrice a day',
}

export const prescriptionDosageMap = (translate: TranslateService) => {
  return {
    [PrescriptionDosage.ONCE_A_DAY]: {
      label: 'Once a day',
    },
    [PrescriptionDosage.TWICE_A_DAY]: {
      label: 'Twice a day',
    },
    [PrescriptionDosage.THRICE_A_DAY]: {
      label: 'Thrice a day',
    }
  };
};

export enum FillStatus {
  NotFilled,

  Filled,
}

export const fillStatusTypesMap = () => {
  return {
    [FillStatus.Filled]: {
      id: FillStatus.Filled,
      name: 'Filled',
      status: 'filled',
      buttonClass: 'button-active-filled'
    },
    [FillStatus.NotFilled]: {
      id: FillStatus.NotFilled,
      name: 'NotFilled',
      status: 'not-filled',
      buttonClass: 'button-active-not-filled'
    }
  };
};

export enum PrescriptionStatus {
  Active = 1,
  Stopped = 2,
  Expired = 3,
  Completed = 4
}

export const prescriptionStatusMap = (translate: TranslateService) => {
  return {
    [PrescriptionStatus.Active]: {
      id: PrescriptionStatus.Active,
      label: 'Active',
      status: 'active-status',
      statusLc: translate.instant('activeLbl'),
      circleClass: 'active-circle',
      buttonClass: 'button-active'
    },
    [PrescriptionStatus.Stopped]: {
      id: PrescriptionStatus.Stopped,
      label: 'Stopped',
      status: 'stopped-status',
      statusLc: translate.instant('stoppedLbl'),
      circleClass: 'stopped-circle',
      buttonClass: 'button-stopped'
    },
    [PrescriptionStatus.Expired]: {
      id: PrescriptionStatus.Expired,
      label: 'Expired',
      status: 'expired-status',
      statusLc: translate.instant('expiredLbl'),
      circleClass: 'expired-circle',
      buttonClass: 'button-expired'
    },
    [PrescriptionStatus.Completed]: {
      id: PrescriptionStatus.Completed,
      label: 'Completed',
      status: 'completed-status',
      statusLc: translate.instant('completedLbl'),
      circleClass: 'completed-circle',
      buttonClass: 'button-completed'
    }
  };
};